<template>
  <div>
    <NavMain />

    <div
      class="grid grid-cols-6 sm:grid-cols-6 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-6"
    >
      <div class="col-span-6 lg:grid xl:grid lg:col-span-1 xl:col-span-1">
        <SearchPane />
      </div>
      <div
        class="col-span-6 lg:grid xl:grid lg:col-span-4 xl:col-span-4 mt-0 sm:mt-0 md:mt-0 lg:mt-4 xl:mt-4 mx-0 sm:mx-0 md:mx-0 lg:mx-2 xl:mx-2"
      >
        <a id="searchResults" class="lg:hidden xl:hidden" />
        <Accommodaties />
      </div>

      <div
        class="hidden sm:hidden md:hidden lg:grid xl:grid lg:col-span-1 xl:col-span-1"
      ></div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Accommodaties from "../components/SearchResults/Accommodaties";
import NavMain from "../components/NavMain";
import SearchPane from "../components/AccommodatieSearch/Pane";

import Footer from "../components/Footer";

export default {
  components: {
    Accommodaties,
    NavMain,
    SearchPane,
    Footer
  }
};
</script>
